import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import {Layout} from "antd";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import LeftSidebar from "../../components/LeftSidebar/LeftSidebar";
import SettingSidebar from "../../components/SettingSidebar/SettingSidebar";
import useResponsive from "../../../../../hooks/useResponsive";
import {DataContext} from "../../../../../context/data/DataContext";
import '../../../../../assets/scss/theme/admin/style.scss';

export const SettingLayout: React.FC = () => {
    const dataContext = useContext(DataContext);
    const { isMobile } = useResponsive();
    useEffect(() => {
        if (isMobile) {
            dataContext.setSidebarVisible(false);
        }
    }, [isMobile]);

    return (
        <Layout id={"admin-theme-wrapper"} className={`app-wrapper admin-theme-wrapper ${dataContext.sidebarVisible ? '' : 'hide-sidebar'}`}>
            <Header />
            <Layout className="setting-layout">
                <LeftSidebar />
                <SettingSidebar />
                <Layout.Content className="content-wrapper">
                    <div className="main-content">
                        <Outlet />
                    </div>
                </Layout.Content>
            </Layout>
            <Footer />
        </Layout>
    )
}
